import InvoiceUpload from "./InvoiceUpload";

export default InvoiceUpload;
